import React from 'react';
import { Helmet } from "react-helmet";
import '../../search_doctor.style';
import { City_1321_17 as City } from './item';

export class City_1321_17_Component extends React.Component {
    constructor( props ) {
        super();
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>{`Все мануальные терапевты Нижнего новгорода - Медицинский портал Нижегородской области: информация о врачах и учреждениях здравоохранения`}</title>
                    <meta property='og:title' content={`Все мануальные терапевты Нижнего новгорода - Медицинский портал Нижегородской области: информация о врачах и учреждениях здравоохранения`} />
                    <meta name="description" content={`Лучшие мануальные терапевты Нижнего новгорода, отзывы, контакты, адрес, услуги, фото работ. Удобный поиск мануальных терапевтов Нижнего новгорода. Все о врачах-мануальных терапевтах Нижнего новгорода на 52c.ru`} />
                    <meta name="og:description" content={`Лучшие мануальные терапевты Нижнего новгорода, отзывы, контакты, адрес, услуги, фото работ. Удобный поиск мануальных терапевтов Нижнего новгорода. Все о врачах-мануальных терапевтах Нижнего новгорода на 52c.ru`} />
                </Helmet>
                <City />
            </>
        );
    }
}